module.exports = __webpack_public_path__ + "img/2_en.f2872e0.png";